import { Css } from "@homebound/beam";

export const maxWidthCheckboxLabel = "maxWidthCheckboxLabel";

export const css = { [`.${maxWidthCheckboxLabel} > label`]: Css.maxw100.$ };
